import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Container } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { InputGroup } from 'react-bootstrap';

import { useState, useEffect } from 'react';
import RecipeIngredientDisplay from './RecipeIngredientDisplay';
import { Modal } from 'react-bootstrap';

import api_url from '../../config/api_url';
import { authHeaders } from '../../utils/authHeaders';





const RecipeIngredientList = (props) => {

    const [recipeIngredients, setRecipeIngredients] = useState([]);
    const [isVisible, setVisible] = useState(false);
    const [param, setParam] = useState("");
    const [show, setShow] = useState(false);
    const [currentIdx, setCurrentIdx] = useState(0);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);



    useEffect(() => {
        
        if(props.recipeId === undefined) {
            console.log("err props obj is undefined still xdddd");
            console.log(props);

            return;
        }
        console.log("rec ing list");
        console.log(props);
        let isSubscribed = true;

        // declare the async data fetching function
        const fetchData = async () => {
          // get the data from the api
          
        
          const fetchUrl = api_url + "/api/recipes/ingredients/" +  props.recipeId;
          const data = await fetch(fetchUrl);
          const json = await data.json();

          //const data = [{name: "abc", id: 1, price:"12dkk",}, {name: "efg", id: 2, price:"12dkk"}, {name:param, id: 3, price:"14dkk"} ]
          // convert the data to json
          //const json = await response.json();
        
          // set state with the result if `isSubscribed` is true
          if (isSubscribed) {
            setRecipeIngredients(json);
          }
        }
      
        // call the function
        fetchData()
          // make sure to catch any error
          .catch(console.error);;
      
        // cancel any future `setData`
        return () => isSubscribed = false;
      }, [isVisible])

    useEffect(()=>{
        setVisible(props.isVisible);
        console.log("use effect, is visible");
        console.log(isVisible);
    }, [props.isVisible])

    const removeHandler = (idx) => {
        handleShow();
        setCurrentIdx(idx);
    }

    const editHandler = async (idx, obj) => {

        let differs = false;
        //compare properties:
        for(const key of Object.keys(obj)) {
            if(obj[key]!=recipeIngredients[idx][key]) {
                differs = true;
            }
        }
        if(!differs) {
            return;
        }


        if(obj.ingredient_id === undefined || obj.weight === undefined) {
            return;
        }

        if(recipeIngredients[idx].ingredient_id == obj.ingredient_id && recipeIngredients[idx].ingredient_id == obj.weight) {
            console.log("unchanged!!");
            return;
        }


        if(obj.id !== undefined) {
            const response = await fetch(api_url + '/api/recipes/ingredients', {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    ...authHeaders()
                },
                body: JSON.stringify({recipeIngr: obj})
              });

        } else {

            const response = await fetch(api_url + '/api/recipes/ingredients', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    ...authHeaders()
                },
                body: JSON.stringify({recipeIngr: obj})
              });
              let json = await response.json();
              obj = json;
        }
        

        setRecipeIngredients([
            ...recipeIngredients.slice(0, idx),
            obj,
            ...recipeIngredients.slice(idx +1 )
        ]);


    }

    const deleteRecipeIngredient = async () => {
        handleClose();

        const response = await fetch(api_url + '/api/recipes/ingredients', {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                ...authHeaders()
            },
            body: JSON.stringify({id: recipeIngredients[currentIdx].id})
          });

        


        setRecipeIngredients([
            ...recipeIngredients.slice(0, currentIdx),
            ...recipeIngredients.slice(currentIdx + 1)
          ]);
    }

    const addNewRecipeIngredient = () => {
        setRecipeIngredients([...recipeIngredients, {recipe_id: props.recipeId}])
    }

    

    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Slet Ingrediens</Modal.Title>
                </Modal.Header>
                <Modal.Body>Er du sikker på du vil slette ingrediensen {recipeIngredients.length > 0 ? recipeIngredients[currentIdx].name : "ERROR"}?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Tilbage
                    </Button>
                    <Button variant="primary" onClick={deleteRecipeIngredient}>
                        Slet
                    </Button>
                </Modal.Footer>
            </Modal>

        <Row className={"justify-content-center" + (isVisible ? "justify-content-center" : "justify-content-center d-none")}>
            <Col xs={10}>
                <Button onClick={addNewRecipeIngredient}>Tilføj en ny ingrediens</Button>
            </Col>
            {recipeIngredients.length > 0 ? recipeIngredients.map((recipe, i) => <RecipeIngredientDisplay obj={recipe} key={i} index={i} deleteFunction={removeHandler} editFunction={editHandler} />) : null}

        </Row>
        </>
        
    );

}

export default RecipeIngredientList;